import angular from "angular";
import angularUIB from "angular-ui-bootstrap";
import angularMoment from "angular-moment";
import user from "./user";
import core from "../core/core.module";
import userForm from "./user-form/user-form";

angular
    .module('usersControl.component', [
        angularUIB,
        angularMoment,
        user,
        core,
        userForm
    ])
    .component('usersControl', {
        controller: ['User', '$uibModal', 'notifier', 'Auth', 'Data', controller],
        template: require('./users-control.component.html'),
        bindings: {
            params: '<'
        }
    });

function controller(User, $uibModal, notifier, Auth, Data) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.id = null;
        $ctrl.search = null;
        $ctrl.organization = null;
        $ctrl.status = null;
        $ctrl.currentPage = 1;

        if ($ctrl.params.id) {
            $ctrl.id = $ctrl.params.id;
        }

        $ctrl.getList();
    };

    $ctrl.filterChanged = function () {
        $ctrl.currentPage = 1;
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        User
            .getList({
                currentPage: $ctrl.currentPage,
                id: $ctrl.id,
                search: $ctrl.search,
                organizationId: $ctrl.organization ? $ctrl.organization.id : null,
                status: $ctrl.status,
            })
            .then(
                function (response) {
                    $ctrl.users = response.data.users;
                    $ctrl.totalCount = response.data.totalCount;
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            );
    };

    $ctrl.getOrganizations = function (fragment) {
        return Data.getOrganizations(fragment);
    };

    $ctrl.edit = function (user) {
        if (!Auth.can('users_control.crud')) {
            return;
        }
        $uibModal
            .open({
                component: 'userForm',
                resolve: {
                    user: function () {
                        return user;
                    }
                }
            })
            .result
            .then(
                function (result) {
                    user.first_name = result.first_name;
                    user.last_name = result.last_name;
                    user.email = result.email;
                    user.is_active = result.is_active;
                    user.position = result.position;
                    user.phone = result.phone;
                    user.code = result.code
                },
                function () {
                },
            );
    };

}

export default 'usersControl.component';


// WEBPACK FOOTER //
// ./resources/assets/modules/users-control/users-control.component.js